<template>
    <div>
      <img
          class="waterMark_img position-absolute"
          :style="{
              filter: `drop-shadow(5px 5px 5px rgba(0, 0, 0,  ${shadowOpacity}))`,
              opacity: imgOpacity,
              top: topPosition,
              left: leftPosition,
            }"
          :src="imageUrl"
          alt="waterMark_img">
    </div>
</template>

<script setup>
import {ref, reactive, watchEffect} from "vue";
import defaultValue from "@/utils/defaultValue"
import freeImg from "@/utils/freeImg";
import {useRoute} from "vue-router";

const route = useRoute()
const props = defineProps(['watermarkData'])
const {defaultWidth, defaultHeight} = defaultValue()
const {freeImages} = freeImg()

const waterMarkInfo = reactive(props.watermarkData)
const defaultPadding = '22'
const defaultOpacity = '75'
const topPosition = ref('')
const leftPosition = ref('')
const imgOpacity = ref('')
const shadowOpacity = ref('')
const imageUrl = ref('')

watchEffect(() => {
  const {
    HasImage,
    Image,
    Horizontal,
    Vertical,
    Shadow,
    Opacity
  } = waterMarkInfo

  if (!HasImage) return false

  if (route.meta.mode === 'controller') {
    const imgSplit = Image.split('.')
    imageUrl.value = freeImages[imgSplit[0]]
  }
  else if (Image !== '') imageUrl.value = Image
  else imageUrl.value = ''

  leftPosition.value = parseInt(Horizontal) > 0 ? `${Horizontal}%` : `${defaultPadding}px`
  topPosition.value = parseInt(Vertical) > 0 ? `${Vertical}%` : `${defaultPadding}px`
  imgOpacity.value = parseInt(Opacity) >= 0 ? `${Opacity}%` : `${defaultOpacity}%`
  shadowOpacity.value = parseInt(Shadow) >= 0 ? `${Shadow}%` : `${defaultOpacity}%`


})
</script>

<style lang="scss">
@import "~@/assets/scss/components/Watermark.scss";
</style>
